module.exports = __webpack_public_path__ + "static/media/practice-connect.6065c32e.png";